export const FieldsType = {
  dateTime: 'datetime',
  bool: 'boolean',
  string: 'string',
  number: 'number',
  guid: 'guid',
  xdm: 'xdm',
  multiSelect: 'multiselect',
  singleSelect: 'singleselect',
  xdmContext: 'xdmcontext',
};
